import store from "../store";

export default function guest({ next, router, to }) {
  if (to.name === "Validate SalesOrder") {
    return next();
  }
  if (store.getters.isAuthenticated) {
    return router.push({ path: "/dashboard" });
  }

  return next();
}
